export function sortArrayByProperty<T>(
    items: T[],
    orderFn: (item: T) => any,
    reverse?: boolean,
    nullValuesAtTheEnd?: boolean,
) {
    return items.sort(comparator(orderFn, reverse, nullValuesAtTheEnd));
}

export const comparator = (orderFn: (item) => number, reverse?: boolean, nullValuesAtTheEnd?: boolean) => (a, b) => {
    const orderA = orderFn(a);
    const orderB = orderFn(b);
    const mul = reverse ? -1 : 1;
    if (orderA == orderB) {
        return 0;
    }

    if (nullValuesAtTheEnd) {
        if (orderA === null) {
            return mul;
        } else if (orderB === null) {
            return -mul;
        }
    }

    return orderA < orderB ? mul * -1 : mul * 1;
};

export const propComparator = (propName, reverse?: boolean, nullValuesAtTheEnd?: boolean) =>
    comparator(
        (item) => {
            return item[propName];
        },
        reverse,
        nullValuesAtTheEnd,
    );
